// 👇👇👇👇👇👇DEVLOPMENT URL👇👇👇👇👇👇👇👇
// const baseUrl = "http://localhost:5000/api/v1"
// const baseUrl2 = "http://192.168.1.13:5001/api/v1"
// const serverUrl = "http://192.168.1.13:5001"
// const clintUrl = "http://localhost:3000"
// const socketUrl = "http://localhost:5002"


// 👇👇👇👇👇👇TEST URL👇👇👇👇👇👇👇👇
// const baseUrl = "https://dev-alpha.app-assertai.com:5000/api/v1";
// const baseUrl2 = "https://dev-backend1.app-assertai.com/api/v1"
// const serverUrl = "https://dev-backend1.app-assertai.com";
// const clintUrl = "https://pratham.app-assertai.com"
// const socketUrl = "https://pratham.app-assertai.com:5000"

// 👇👇👇👇👇👇PRODUCTION URL👇👇👇👇👇👇👇👇
// const baseUrl = "https://backend.app-assertai.com/api/v1";
// const baseUrl2 = "https://backend1.app-assertai.com/api/v1"
// const serverUrl = "https://backend1.app-assertai.com";
// const clintUrl = "https://prathamlive.ai"
// const socketUrl = "https://pratham.app-assertai.com:5000"

// 👇👇👇👇👇👇PRODUCTION URL for LOcal👇👇👇👇👇👇👇👇
const baseUrl = "https://backend.app-assertai.com/api/v1";
const baseUrl2 = "https://localpratham.app-assertai.com/api/v1"
const serverUrl = "https://localpratham.app-assertai.com";
const clintUrl = "https://pratham.app-assertai.com"
const socketUrl = "https://pratham.app-assertai.com:5000"

// 👇👇👇👇👇👇FLIPCART URL👇👇👇👇👇👇👇👇
// const baseUrl = "http://34.27.2.73:5000/api/v1"
// const baseUrl2 = "http://34.27.2.73:8000/api/v1"
// const serverUrl = "http://34.27.2.73:5000"
// const socketUrl = "http://34.27.2.73:8000"
// const clintUrl = "http://34.27.2.73"

// 👇👇👇👇👇👇FLIPCART URL👇👇👇👇👇👇👇👇
// const baseUrl = "https://flipkart.app-assertai.com:5000/api/v1"
// const baseUrl2 = "https://flipkart.app-assertai.com:8000/api/v1"
// const serverUrl = "https://flipkart.app-assertai.com:5000"
// const socketUrl = "https://flipkart.app-assertai.com:8000"
// const clintUrl = "https://flipkart.app-assertai.com"


// 👇👇👇👇👇👇PRATHAM URL👇👇👇👇👇👇👇👇
const apiUrl = "https://feed.app-assertai.com:8080/start"
const appendApi = "https://feed.app-assertai.com:8080"

export { serverUrl,clintUrl,apiUrl,appendApi,socketUrl,baseUrl2 };

export default baseUrl;
